import { useEffect, useState } from "react";
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { routes } from "../config/routes";
import { siteConfig } from "../config/site";

const navigation = [
  { label: "Shop", to: routes.shop },
  { label: "About", to: routes.about },
  { label: "Delivery & Returns", to: routes.delivery },
  { label: "FAQ", to: routes.faq }
];

function Wordmark() {
  return (
    <>
      <span className="wordmark-mark" aria-hidden="true">
        BO
      </span>
      <span className="wordmark-name">
        Beautify <i>Ourselves</i>
      </span>
    </>
  );
}

export function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <>
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <div className="preview-bar">{siteConfig.prelaunchNotice}</div>
      <header className="site-header">
        <Link className="wordmark" to="/" aria-label={`${siteConfig.brandName} home`}>
          <Wordmark />
        </Link>
        <button
          className="nav-toggle"
          type="button"
          aria-expanded={open}
          aria-controls="site-nav"
          onClick={() => setOpen((value) => !value)}
        >
          <span className="sr-only">Open menu</span>
          <span />
          <span />
        </button>
        <nav
          id="site-nav"
          className={`site-nav${open ? " is-open" : ""}`}
          aria-label="Primary navigation"
        >
          {navigation.map((item) => (
            <NavLink key={item.to} to={item.to}>
              {item.label}
            </NavLink>
          ))}
        </nav>
      </header>
    </>
  );
}

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-main">
        <div>
          <Link className="wordmark wordmark-light" to="/">
            <Wordmark />
          </Link>
          <p>Beauty, chosen with care and explained clearly.</p>
        </div>
        <div>
          <h2>Visit</h2>
          <Link to={routes.shop}>Shop</Link>
          <Link to={routes.about}>About us</Link>
        </div>
        <div>
          <h2>Help</h2>
          <Link to={routes.delivery}>Delivery & Returns</Link>
          <Link to={routes.faq}>Frequently asked questions</Link>
        </div>
        <div>
          <h2>Shopping</h2>
          <p>
            Prices will be shown in GBP.
            <br />
            UK and Republic of Ireland delivery information is listed separately.
          </p>
        </div>
      </div>
      <div className="footer-bottom">
        <span>
          © {new Date().getFullYear()} {siteConfig.brandName}
        </span>
        <span>No orders or payments are being accepted.</span>
      </div>
    </footer>
  );
}

function ScrollToTop() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return null;
}

export function Layout() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <Outlet />
      <Footer />
    </>
  );
}
